import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"
import List from "app/stores/list"
import { getCurrentApp } from 'app/api/localTools'

export default class Store {
  @observable recoveryTableData = []
  @observable shareList = []
  @observable detailData = {}
  @observable list

  @action deleteReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/${getCurrentApp()}/groups/${groupId}/reports/${reportId}`)
    .checkToken()
    .commonDispose()
  }

  @action recoveryReport = (groupId, reportId) => {
    return request.put(`${config.backend}/${getCurrentApp()}/groups/${groupId}/reports/${reportId}/recovery`)
    .checkToken()
    .commonDispose()
  }

  /*
   * @query: 获取数据的类型
   */
  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/${getCurrentApp()}/groups/${groupId}/reports?state=${query}`)
    .checkToken()
    .commonDispose()
    .then(
      res => {
        this.recoveryTableData = res
      }
    )
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/azf/reports/${reportId}`)
    .checkToken()
    .commonDispose()
      .then(res => {
          this.detailData = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action shareGroup = (groupId, username) => {
    return request.put(`${config.backend}/azf/groups/${groupId}/share/${username}`)
    .checkToken()
    .commonDispose()
  }

  @action dataSwitch = (reportId) => {
    return request.get(`${config.backend}/azf/reports/${reportId}`)
    .checkToken()
    .commonDispose()
  }

  @action deleteReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/azf/groups/${groupId}/reports/${reportId}`)
    .checkToken()
    .commonDispose()
  }

  @action clearDetailData = () => {
    this.detailData = {}
  }

  @action recoveryReport = (groupId, reportId) => {
    return request.put(`${config.backend}/azf/groups/${groupId}/reports/${reportId}/recovery`)
    .checkToken()
    .commonDispose()
  }

  @action getHistory = (groupId) => {
    return request.get(`${config.backend}/azf/groups/${groupId}/history`)
    .checkToken()
    .commonDispose()
  }

  /*
   * @query: 获取数据的类型
   */
  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/azf/groups/${groupId}/reports?state=${query}`)
    .checkToken()
    .commonDispose()
    .then(
      res => {
        this.recoveryTableData = res
      }
    )
  }

  @action clearRecoveryTableData = () => {
    this.recoveryTableData = []
  }

  @action updateGroup = (groupId, groupName) => {
    return request.put(`${config.backend}/azf/groups/${groupId}/reports`)
    .send({groupName})
    .checkToken()
    .commonDispose()
  }

  @action getReportByAppId = (appId) => {
    return request.get(`${config.backend}/azf/reports/apps/${appId}`)
    .checkToken()
    .commonDispose()
  }

  @action getSearchData = (appId, keyword) => {
    return request.get(`${config.backend}/azf/reports/apps/${appId}?keywords=${keyword}`)
    .checkToken()
    .commonDispose()
  }

  @action createNewGroup = (newGroupData) => {
    return request.post(`${config.backend}/azf/groups/reports`)
    .send(newGroupData)
    .checkToken()
    .commonDispose()
  }

  @action deleteGroup = (id) => {
    return request.delete(`${config.backend}/azf/groups/${id}/reports`)
    .checkToken()
    .commonDispose()
  }

  @action getShareList = (id) => {
    return request.get(`${config.backend}/azf/groups/${id}/share`)
    .checkToken()
    .commonDispose()
    .then(
      res => {
        this.shareList = res
      },
      err => {
        message.error(err.message)
      }
    )
  }
  @action cancelShare = (groupId, ownerId, type) => {
    if (type === 'toId') {
      return request.delete(`${config.backend}/azf/groups/${groupId}/share?${type}=${ownerId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          const index = this.shareList.findIndex(
            shared => {
              return shared.toId === ownerId
            }
          )
          this.shareList.splice(index, 1)
          message.success("取消分享成功")
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
    } else {
      return request.delete(`${config.backend}/azf/groups/${groupId}/share`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.list.filterData()
          message.success("取消分享成功")
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
    }
  }

  @action downloadCsvStep = (groupId, templateId, versionId) => {
    return request.get(
      `${config.backend}/azf/groups/${groupId}/statistic`
    )
    .checkToken()
    .commonDispose()
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "azf/groups/reports")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/azf/report.js